// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { AxiosConfig, createAxios } from 'ts/createAxios';
import {
  WorkHistoriesEmissionsCollectedResponse,
  WorkHistoriesEmissionsRequestResponse,
} from 'types/workHistoriesTypes';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import { GetEmissionParams } from 'util/Types';

export async function getEmissionWorkHistories<
  T extends 'requests' | 'collected'
>(p?: {
  type: T;
  params?: GetEmissionParams;
  axiosConfigs?: AxiosConfig;
  successCallback?: (
    data: T extends 'requests'
      ? WorkHistoriesEmissionsRequestResponse
      : WorkHistoriesEmissionsCollectedResponse
  ) => void;
  failedCallback?: (err: unknown) => void;
  finallyCallback?: () => void;
}) {
  const {
    type,
    successCallback,
    failedCallback,
    finallyCallback,
    params,
    axiosConfigs,
  } = p ?? {};

  try {
    const { data } = await createAxios({
      ...axiosConfigs,
      prefix: 'v2',
    }).post<
      T extends 'requests'
        ? WorkHistoriesEmissionsRequestResponse
        : WorkHistoriesEmissionsCollectedResponse
    >(
      type === 'requests'
        ? API_ENDPOINTS.EMISSIONS_REQUEST_HISTORIES
        : API_ENDPOINTS.EMISSIONS_COLLECTED_HISTORIES,
      {
        ...params,
      }
    );

    successCallback?.(data);
  } catch (err) {
    handleError(err);
    failedCallback?.(err);
  } finally {
    finallyCallback?.();
  }
}
